import React, { PureComponent } from 'react'
import { localize } from 'helpers/translator/localize'

import config from 'config'
import FullOverlay from 'views/overlay/full_overlay/FullOverlay'
import Bodymovin from 'components/bodymovin/bodymovin'

const gsTransitionAnimation = `${config.www_cdn}assets/media/animations/gs-transition.json`

class GoogleSlidesTransitionOverlay extends PureComponent {

	createAsset() {
		return (
			<Bodymovin
				path={gsTransitionAnimation}
				loop={true}
			>
				<div></div>
			</Bodymovin>
		)
	}

	render() {
		return (
			<FullOverlay
				shouldShowHeader={false}
				assetSource={this.createAsset()}
				title={localize('googleSlides_transition_overlay_title')}
			/>
		)
	}
}

export default GoogleSlidesTransitionOverlay
